import { useEffect, useState } from 'react';
import { connect, useDispatch } from "react-redux";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Col, Row } from "reactstrap";
import "../../../css/dashboard.scss";
import { logout } from "../../../store/actions/AuthActions";
import { api } from "../../../utils/api";
import { digitFormat } from "../../../utils/function";
import { translate } from "../../../utils/translate";
import InfoBox from "../Common/InfoBox";

const Dashboard = (props) => {
    const [loadingDashboard, setLoadingDashboard] = useState(false);
    const [dashboardInfo, setDashboardInfo] = useState(null);
    const dispatch = useDispatch();

    useEffect(() => {
        getDashboard();
    }, [props.lang, props.auth.auth.access_token]);

    const getDashboard = () => {
        setLoadingDashboard(true);
        fetch(api.dashboard, {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept-Language": props.lang.toLowerCase(),
                "Authorization": "Bearer " + props.auth.auth.access_token
            }),
        })
            .then(response => response.json())
            .then(responseJson => {
                setTimeout(() => {
                    setLoadingDashboard(false);
                }, 1000);
                if (responseJson.status === "success") {
                    setDashboardInfo(responseJson.data);
                } else {
                    if (responseJson.status === 'error' && responseJson.message.toLowerCase() === 'token expired') {
                        dispatch(logout(props.history, 'login'));
                    }
                }
            }).catch(error => {
                console.error("error", error);
            });
    }

    return (
        <>
            <div className='dashboard pb-5'>
                <Row className="justify-content-center px-0 mx-0 mt-3">
                    <Col lg={12} md={12} sm={12} xs={12} className="mb-4 h-100 px-0">
                        <Row className="justify-content-start px-0 mx-0">
                            <Col lg={4} md={6} sm={12} xs={12} className="mb-3">
                                <InfoBox
                                    boxLabel={translate(props.lang, "Total Register Account")}
                                    boxValue={dashboardInfo && dashboardInfo.total_register_account ? Number(dashboardInfo.total_register_account).toLocaleString('en-US') : "-"}
                                    loading={loadingDashboard}
                                />
                            </Col>
                            <Col lg={4} md={6} sm={12} xs={12} className="mb-3">
                                <InfoBox
                                    boxLabel={translate(props.lang, "Total Deposit Account")}
                                    boxValue={dashboardInfo && dashboardInfo.total_deposit_account ? Number(dashboardInfo.total_deposit_account).toLocaleString('en-US') : "-"}
                                    loading={loadingDashboard}
                                />
                            </Col>
                            <Col lg={4} md={6} sm={12} xs={12} className="mb-3">
                                <InfoBox
                                    boxLabel={translate(props.lang, "Total MT5 Balance")}
                                    boxValue={dashboardInfo && dashboardInfo.total_mt5_balance ? Number(dashboardInfo.total_mt5_balance).toLocaleString('en-US', digitFormat) : "-"}
                                    loading={loadingDashboard}
                                />
                            </Col>
                            <Col lg={4} md={6} sm={12} xs={12} className="mb-3">
                                <InfoBox
                                    boxLabel={translate(props.lang, "Total Wallet Balance")}
                                    boxValue={dashboardInfo && dashboardInfo.total_wallet_balance ? Number(dashboardInfo.total_wallet_balance).toLocaleString('en-US', digitFormat) : "-"}
                                    loading={loadingDashboard}
                                />
                            </Col>
                            <Col lg={4} md={6} sm={12} xs={12} className="mb-3">
                                <InfoBox
                                    boxLabel={translate(props.lang, "Total Withdraw Amount")}
                                    boxValue={dashboardInfo && dashboardInfo.total_withdraw_amount ? Number(dashboardInfo.total_withdraw_amount).toLocaleString('en-US', digitFormat) : "-"}
                                    loading={loadingDashboard}
                                />
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </div>
        </>
    )
}

const mapStateToProps = state => {
    const { auth, i18n } = state;
    return {
        lang: i18n.lang,
        auth: auth,
    }
}

export default connect(mapStateToProps)(Dashboard);